<div *ngIf="isRfqs; else kits">
  <div *ngIf="controlName; else nullControlName">
    <ng-select
      *ngIf="isUsingOnScrollToEnd; else others"
      [items]="rfqsBuffer"
      [multiple]="false"
      [trackByFn]="trackByFn"
      appendTo="body"
      [clearable]="true"
      [loading]="rfqLoading"
      [typeahead]="rfqInput$"
      [formControlName]="controlName"
      (change)="selectItem($event)"
      name="rfqProduct"
      [searchFn]="customSearchFn"
      [addTag]="addTagFn()"
      [closeOnSelect]="closeOnSelect"
      [hideSelected]="false"
      (close)="resetSelectedItems()"
      [id]="itemRowId"
      [isOpen]="isOpen"
      (focus)="isOpen = true"
      (blur)="isOpen = false"
      (open)="isOpen = true"
      (scroll)="onScroll($event)"
      (scrollToEnd)="onScrollToEnd()"
      class="line-items-multiselect"
      #selectComponent
    >
      <!-- <ng-template ng-footer-tmp *ngIf="selectedIds.length">
        <button
          class="btn btn-sm w-100 btn-light"
          type="button"
          (click)="addSelectedItems()"
        >
          Add {{ selectedIds.length }} selected items
        </button>
      </ng-template> -->
      <ng-template ng-label-tmp let-item="item">
        <span *ngIf="item && item.id > 0">
          {{ item.product_name }}
        </span>
        <span *ngIf="item && item.id == 0">{{ item.product_name }}</span>
      </ng-template>
      <ng-template
        ng-option-tmp
        let-item="item"
        let-index="index"
        let-search="searchTerm"
      >
        <div (click)="add(item)" class="position-relative">
          <div
            class="d-flex justify-content-end selected-badge"
            *ngIf="selectedIds.includes(item.id)"
          >
            <span class="badge badge-success text-sm"> ADDED </span>
          </div>
          <div
            *ngIf="item && item.id && item.product_description; else no_description"
          >
            <div class="row">
              <div class="col-md-1" *ngIf="checkImage(item); else noImage">
                <img
                  [src]="getItemImage(item)"
                  (error)="changeSource($event, 'assets/media/')"
                />
              </div>
              <ng-template #noImage>
                <div class="col-md-1">
                  <img src="assets/media/no_image_placeholder.jpg" />
                </div>
              </ng-template>
              <div class="col-md modified text-wrap">
                <span *ngIf="item && item.id > 0"
                  ><p>
                    {{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]
                  </p></span
                >
                <span *ngIf="item && item.id == 0"
                  ><p>{{ item.product_name }}</p></span
                >
                <small class="description"
                  ><span
                    [innerHTML]="
                      item.product_description.length > 300
                        ? (item.product_description | slice: 0 : 300) + '..'
                        : item.product_description
                    "
                  ></span>
                  <span *ngIf="item.is_discontinued == 1">
                    | <b class="text-warning">DISCONTINUED</b></span
                  >
                  <span *ngIf="item.is_kit && item.is_kit == 1">
                    | <b class="text-info">KIT</b></span
                  ></small
                >
              </div>
            </div>
          </div>
          <ng-template #no_description>
            <div class="row">
              <div class="col-md-1" *ngIf="checkImage(item); else noImage">
                <img
                  [src]="getItemImage(item)"
                  (error)="changeSource($event, 'assets/media/')"
                />
              </div>
              <ng-template #noImage>
                <div class="col-md-1">
                  <img src="assets/media/no_image_placeholder.jpg" />
                </div>
              </ng-template>
              <div class="col-md modified text-wrap">
                <span *ngIf="item && item.id > 0"
                  ><p>
                    {{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]
                  </p></span
                >
                <span *ngIf="item && item.id == 0"
                  ><p>{{ item.product_name }}</p></span
                >
                <small class="description">
                  <span *ngIf="item.is_discontinued == 1"
                    ><b class="text-warning">DISCONTINUED</b></span
                  >
                  <span *ngIf="item.is_kit && item.is_kit == 1">
                    | <b class="text-info">KIT</b></span
                  >
                </small>
              </div>
            </div>
          </ng-template>
        </div>
      </ng-template>
    </ng-select>
    <ng-template #others>
      <ng-select
        [items]="rfqs$ | async"
        [multiple]="false"
        [trackByFn]="trackByFn"
        appendTo="body"
        [clearable]="true"
        [loading]="rfqLoading"
        [typeahead]="rfqInput$"
        [formControlName]="controlName"
        name="rfqProduct"
        [id]="itemRowId"
        (change)="selectItem($event)"
      >
        <ng-template ng-label-tmp let-item="item">
          <span *ngIf="item && item.id">
            {{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]
          </span>
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-index="index"
          let-search="searchTerm"
        >
          <div
            *ngIf="item && item.id && item.product_description; else no_description"
          >
            <div class="row">
              <div class="col-md-1" *ngIf="checkImage(item); else noImage">
                <img
                  [src]="getItemImage(item)"
                  (error)="changeSource($event, 'assets/media/')"
                />
              </div>
              <ng-template #noImage>
                <div class="col-md-1">
                  <img src="assets/media/no_image_placeholder.jpg" />
                </div>
              </ng-template>
              <div class="col-md modified text-wrap">
                <span *ngIf="item && item.id > 0"
                  ><p>
                    {{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]
                  </p></span
                >
                <span *ngIf="item && item.id == 0"
                  ><p>{{ item.product_name }}</p></span
                >
                <small class="description"
                  ><span
                    [innerHTML]="
                      item.product_description.length > 300
                        ? (item.product_description | slice: 0 : 300) + '..'
                        : item.product_description
                    "
                  ></span>
                  <span *ngIf="item.is_discontinued == 1">
                    | <b class="text-warning">DISCONTINUED</b></span
                  >
                  <span *ngIf="item.is_kit && item.is_kit == 1">
                    | <b class="text-info">KIT</b></span
                  ></small
                >
              </div>
            </div>
          </div>
          <ng-template #no_description>
            <div class="row">
              <div class="col-md-1" *ngIf="checkImage(item); else noImage">
                <img
                  [src]="getItemImage(item)"
                  (error)="changeSource($event, 'assets/media/')"
                />
              </div>
              <ng-template #noImage>
                <div class="col-md-1">
                  <img src="assets/media/no_image_placeholder.jpg" />
                </div>
              </ng-template>
              <div class="col-md modified text-wrap">
                <span *ngIf="item && item.id > 0"
                  ><p>
                    {{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]
                  </p></span
                >
                <span *ngIf="item && item.id == 0"
                  ><p>{{ item.product_name }}</p></span
                >
                <small class="description">
                  <span *ngIf="item.is_discontinued == 1"
                    ><b class="text-warning">DISCONTINUED</b></span
                  >
                  <span *ngIf="item.is_kit && item.is_kit == 1">
                    | <b class="text-info">KIT</b></span
                  >
                </small>
              </div>
            </div>
          </ng-template>
        </ng-template>
      </ng-select>
    </ng-template>
  </div>
  <ng-template #nullControlName>
    <ng-select
      [items]="rfqs$ | async"
      [multiple]="false"
      [trackByFn]="trackByFn"
      appendTo="body"
      [clearable]="true"
      [loading]="rfqLoading"
      [typeahead]="rfqInput$"
      (change)="selectItem($event)"
      name="rfqProduct"
      [id]="itemRowId"
    >
      <ng-template ng-label-tmp let-item="item">
        <span *ngIf="item && item.id > 0"
          ><p>
            {{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]
          </p></span
        >
        <span *ngIf="item && item.id == 0"
          ><p>{{ item.product_name }}</p></span
        >
      </ng-template>
      <ng-template
        ng-option-tmp
        let-item="item"
        let-index="index"
        let-search="searchTerm"
      >
        <div
          *ngIf="item && item.id && item.product_description; else no_description"
        >
          <div class="row">
            <div
              class="col-md-1"
              *ngIf="item.photo || item.images?.length; else noImage"
            >
              <img
                [src]="
                  item.photo ||
                  (item.images?.length && item.images[0].thumbnail_url)
                "
                (error)="changeSource($event, 'assets/media/')"
              />
            </div>
            <ng-template #noImage>
              <div class="col-md-1">
                <img src="assets/media/no_image_placeholder.jpg" />
              </div>
            </ng-template>
            <div class="col-md modified text-wrap">
              <span *ngIf="item && item.id > 0"
                ><p>
                  {{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]
                </p></span
              >
              <span *ngIf="item && item.id == 0"
                ><p>{{ item.product_name }}</p></span
              >
              <small class="description"
                ><span
                  [innerHTML]="
                    item.product_description.length > 300
                      ? (item.product_description | slice: 0 : 300) + '..'
                      : item.product_description
                  "
                ></span>
                <span *ngIf="item.is_discontinued == 1">
                  | <b class="text-warning">DISCONTINUED</b></span
                >
                <span *ngIf="item.is_kit && item.is_kit == 1">
                  | <b class="text-info">KIT</b></span
                ></small
              >
            </div>
          </div>
        </div>
        <ng-template #no_description>
          <div class="row">
            <div
              class="col-md-1"
              *ngIf="item.photo || item.images?.length; else noImage"
            >
              <img
                [src]="
                  item.photo ||
                  (item.images?.length && item.images[0].thumbnail_url)
                "
                (error)="changeSource($event, 'assets/media/')"
              />
            </div>
            <ng-template #noImage>
              <div class="col-md-1">
                <img src="assets/media/no_image_placeholder.jpg" />
              </div>
            </ng-template>
            <div class="col-md modified text-wrap">
              <span *ngIf="item && item.id > 0"
                ><p>
                  {{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]
                </p></span
              >
              <span *ngIf="item && item.id == 0"
                ><p>{{ item.product_name }}</p></span
              >
              <small class="description">
                <span *ngIf="item.is_discontinued == 1"
                  ><b class="text-warning">DISCONTINUED</b></span
                >
                <span *ngIf="item.is_kit && item.is_kit == 1">
                  | <b class="text-info">KIT</b></span
                >
              </small>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </ng-select>
  </ng-template>
</div>
<ng-template #kits>
  <ng-select
    [items]="kitsBuffer"
    [multiple]="false"
    [trackByFn]="trackByFn"
    appendTo="body"
    [clearable]="true"
    [loading]="kitLoading"
    [typeahead]="kitInput$"
    (change)="selectItem($event)"
    name="rfqProduct"
    [id]="itemRowId"
    [virtualScroll]="true"
    (scroll)="onScroll($event)"
    (scrollToEnd)="onScrollToEnd()"
    (search)="onSearch($event)"
  >
    <ng-template ng-label-tmp let-item="item">
      <span *ngIf="item && item.id > 0"
        ><p>{{ item.title }} [{{ item.sku ? item.sku : 'N/A' }}]</p></span
      >
      <span *ngIf="item && item.id == 0"
        ><p>{{ item.title }}</p></span
      >
    </ng-template>
    <ng-template
      ng-option-tmp
      let-item="item"
      let-index="index"
      let-search="searchTerm"
    >
      <div *ngIf="item && item.id && item.product_description; else no_description">
        <div class="row">
          <div
            class="col-md-1"
            *ngIf="item.photo || item.images?.length; else noImage"
          >
            <img
              [src]="
                item.photo || (item.images?.length && item.images[0].thumbnail_url)
              "
              (error)="changeSource($event, 'assets/media/')"
            />
          </div>
          <ng-template #noImage>
            <div class="col-md-1">
              <img src="assets/media/no_image_placeholder.jpg" />
            </div>
          </ng-template>
          <div class="col-md modified text-wrap">
            <span *ngIf="item && item.id > 0"
              ><p>{{ item.title }} [{{ item.sku ? item.sku : 'N/A' }}]</p></span
            >
            <span *ngIf="item && item.id == 0"
              ><p>{{ item.title }}</p></span
            >
            <small class="description"
              ><span
                [innerHTML]="
                  item.product_description.length > 300
                    ? (item.product_description | slice: 0 : 300) + '..'
                    : item.product_description
                "
              ></span>
              <span *ngIf="item.is_discontinued == 1">
                | <b class="text-warning">DISCONTINUED</b></span
              >
              <span *ngIf="item.is_kit && item.is_kit == 1">
                | <b class="text-info">KIT</b></span
              ></small
            >
          </div>
        </div>
      </div>
      <ng-template #no_description>
        <div class="row">
          <div
            class="col-md-1"
            *ngIf="item.photo || item.images?.length; else noImage"
          >
            <img
              [src]="
                item.photo || (item.images?.length && item.images[0].thumbnail_url)
              "
              (error)="changeSource($event, 'assets/media/')"
            />
          </div>
          <ng-template #noImage>
            <div class="col-md-1">
              <img src="assets/media/no_image_placeholder.jpg" />
            </div>
          </ng-template>
          <div class="col-md modified text-wrap">
            <span *ngIf="item && item.id > 0"
              ><p>{{ item.title }} [{{ item.sku ? item.sku : 'N/A' }}]</p></span
            >
            <span *ngIf="item && item.id == 0"
              ><p>{{ item.title }}</p></span
            >
            <small class="description">
              <span *ngIf="item.is_discontinued == 1"
                ><b class="text-warning">DISCONTINUED</b></span
              >
              <span *ngIf="item.is_kit && item.is_kit == 1">
                | <b class="text-info">KIT</b></span
              >
            </small>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </ng-select>
</ng-template>
